/**
 * Returns the browser's current locale as an Intl.Locale object
 * @returns {Intl.Locale | null} The browser's current locale or null if unavailable
 */
export const getBrowserLocale = () => {
  try {
    const currentLocale = new Intl.Locale(navigator.language); // Create an Intl.Locale object from the browser's language setting
    return currentLocale;
  } catch (error) {
    return null; // Return null if locale cannot be determined
  }
};

/**
 * Returns the browser's current language as a string
 * @returns {string | null} The browser's current language or null if unavailable
 */
export const getBrowserLanguage = () => {
  const locale = getBrowserLocale(); // Get the Intl.Locale object
  return locale ? locale.language : null; // Return the language code or null
};
